import { TransactionItem, type TransactionListItem } from './TransactionItem'

interface CompletedTransactionItemProps {
  transaction: TransactionListItem
}

export function CompletedTransactionItem({ transaction }: CompletedTransactionItemProps) {
  return <TransactionItem transaction={transaction} variant="completed" />
}
